import { LocationDescriptor, type History } from 'history';
import type { IHistory, IUrl } from './types';

export class ReactRouterHistoryAdapter implements IHistory {

  constructor(private history: History) {}

  private getLocation(url: IUrl): LocationDescriptor {
    return {
      pathname: url.getPath(),
      search: url.getQuery(),
      hash: url.getHash(),
    };
  }

  pushState(url: IUrl): void {
    const location = this.getLocation(url);
    this.history.push(location);
  }

  replaceState(url: IUrl): void {
    const location = this.getLocation(url);
    this.history.replace(location);
  }
}